function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#instagram_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.984 4.704c-.038-.85-.175-1.435-.372-1.941a3.905 3.905 0 00-.925-1.419A3.938 3.938 0 0013.27.422C12.76.225 12.18.088 11.33.05 10.473.01 10.2 0 8.029 0S5.585.01 4.73.047c-.85.037-1.434.175-1.94.372a3.904 3.904 0 00-1.42.925A3.94 3.94 0 00.45 2.76C.252 3.27.115 3.85.077 4.7c-.04.857-.05 1.13-.05 3.302s.01 2.444.047 3.297c.038.85.175 1.435.372 1.941.203.538.519 1.019.925 1.42.4.405.885.721 1.416.921.51.197 1.091.335 1.941.372.854.038 1.126.047 3.298.047s2.444-.01 3.297-.047c.85-.037 1.435-.175 1.941-.372a4.093 4.093 0 002.341-2.34c.197-.51.335-1.092.372-1.942.038-.853.047-1.125.047-3.297 0-2.173-.003-2.445-.04-3.298zm-1.441 6.533c-.035.781-.166 1.203-.275 1.484a2.654 2.654 0 01-1.52 1.52c-.28.109-.706.24-1.484.274-.844.038-1.097.047-3.232.047-2.135 0-2.391-.01-3.232-.047-.781-.034-1.203-.165-1.485-.275a2.462 2.462 0 01-.918-.597 2.488 2.488 0 01-.597-.919c-.11-.28-.241-.706-.275-1.484-.038-.844-.047-1.097-.047-3.232 0-2.135.009-2.391.047-3.232.034-.781.165-1.203.275-1.485.128-.347.33-.662.6-.919.26-.265.572-.469.919-.597.28-.109.706-.24 1.484-.275.844-.037 1.097-.047 3.232-.047 2.138 0 2.391.01 3.232.047.782.035 1.203.166 1.485.275.347.128.662.332.919.597.265.26.469.572.597.92.11.28.24.706.275 1.484.037.844.047 1.097.047 3.232 0 2.135-.01 2.385-.047 3.229z",
  fill: "url(#instagram_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.029 3.891a4.111 4.111 0 000 8.22 4.111 4.111 0 000-8.22zm0 6.777a2.667 2.667 0 110-5.333 2.667 2.667 0 010 5.333z",
  fill: "url(#instagram_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.261 3.729a.96.96 0 11-1.919 0 .96.96 0 011.92 0z",
  fill: "url(#instagram_svg__paint2_linear)"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_svg__paint0_linear",
  x1: 3.027,
  y1: 0,
  x2: 15.508,
  y2: 2.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_svg__paint1_linear",
  x1: 3.027,
  y1: 0,
  x2: 15.508,
  y2: 2.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_svg__paint2_linear",
  x1: 3.027,
  y1: 0,
  x2: 15.508,
  y2: 2.854,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "instagram_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgInstagram;